// redux/slices/sportsBannerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const sportsBannerSlice = createSlice({
  name: "sportsBanner",
  initialState: {
    data: null,
    loading: false,
    error: null
  },

  reducers: {
    getSportsBannerStart: (state, action) => {
      state.loading = true;
      state.error = null;
    },

    getSportsBannerSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },

    getSportsBannerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || "Something went wrong";
    }
  }
});

export const {
  getSportsBannerStart,
  getSportsBannerSuccess,
  getSportsBannerFailure
} = sportsBannerSlice.actions;

export default sportsBannerSlice.reducer;
